<template>
  <ul class="sc-medias flex flex-row">
    <li v-for="media in medias" :key="media.site">
      <a :href="media.src" target="_blank"
        ><i :class="media.site + ' icon'"></i
      ></a>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    medias: Array,
  },
};
</script>
